import { Container, Content, Header, TitleContainer } from 'v3/pages/OnlineContracting/List/styles';
import { OnlineFilters } from 'v3/shared/components/Filters/OnlineFilter';
import { OnlineContractingTable } from 'v3/shared/components/Table/OnlineContractingTable';
import { CommonTemplate } from 'v3/shared/templates/CommonTemplate';
import { HeadlineMedium } from 'v3/shared/typography/HeadlineMedium';

export const OnlineContractingListPage = () => {
  return (
    <CommonTemplate>
      <Container>
        <Content>
          <Header>
            <TitleContainer>
              <HeadlineMedium>Lista de contratos</HeadlineMedium>
            </TitleContainer>
          </Header>
          <OnlineFilters />
          <OnlineContractingTable />
        </Content>
      </Container>
    </CommonTemplate>
  );
};
